<template>
  <div class="load-wrapp indexJust" :class="{ 'load-wrapp-main': textStatus }">
    <div>
      <div class="load-1">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
      <div class="load-text" v-if="!textStatus">{{ textInfo || '正在加载中...' }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    textInfo: '',
    textStatus: false
  },
  data() {
    return {};
  }
};
</script>


<style lang="scss" scoped>
.load-wrapp {
  width: 120px;
  height: 120px;
  padding: 20px;
  text-align: center;
  /* background-color: #d8d8d8; */
  &.load-wrapp-main {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
}

.load-wrapp p {
  padding: 0 0 20px;
}
.load-wrapp:last-child {
  margin-right: 0;
}

.load-1 {
  height: 25px;
}

.line {
  display: inline-block;
  width: 8px;
  height: 10px;
  border-radius: 10px;
  background-color: #30bf30;
}

.load-text {
  font-size: 13px;
  color: #999;
  padding-top: 10px;
}
/* =Animate the stuff
------------------------ */
.load-1 .line:nth-last-child(1) {
  animation: loadingA 1.5s 1s infinite;
}
.load-1 .line:nth-last-child(2) {
  animation: loadingA 1.5s 0.5s infinite;
}
.load-1 .line:nth-last-child(3) {
  animation: loadingA 1.5s 0s infinite;
}

@keyframes loadingA {
  0% {
    height: 10px;
  }
  50% {
    height: 25px;
  }
  100% {
    height: 10px;
  }
}
</style>

<style lang="scss">
.indexJust {
  display: flex;
  display: -ms-flexbox;
  -webkit-display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/module/loading/loading.vue